import React from 'react';
import { Helmet } from 'react-helmet-async';

interface GameSchemaProps {
  game: {
    id: string;
    name: string;
    description?: string | null;
    image_url?: string | null;
    thumb_url?: string | null;
    year?: number | null;
    min_players?: number | null;
    max_players?: number | null;
    play_time?: number | null;
    min_age?: number | null;
    average_rating?: number | null;
    complexity?: number | null;
    slug?: string | null;
  };
}

/**
 * Componente para adicionar Schema.org para informações estruturadas de jogos
 * Melhora a representação nos resultados de busca com rich snippets
 */
const GameSchema: React.FC<GameSchemaProps> = ({ game }) => {
  if (!game) return null;

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": game.name,
    "description": game.description || `${game.name} - Jogo de tabuleiro`,
    "image": game.image_url || game.thumb_url || "https://boardverso.com.br/placeholder-game.jpg",
    "url": `https://boardverso.com.br/games/${game.slug || game.id}`,
    "productID": game.id,
    ...(game.year && { "releaseDate": game.year.toString() }),
    
    ...(game.average_rating && {
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": game.average_rating.toString(),
        "bestRating": "5",
        "worstRating": "1",
        "ratingCount": "1"
      }
    }),
    
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "price": "0",
      "priceCurrency": "BRL",
      "url": `https://boardverso.com.br/games/${game.slug || game.id}`
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default GameSchema; 